import MeetOurTechsPage from './MeetOurTechsPage';

export default MeetOurTechsPage;
